const tenants: Record<string, App.Tenant> = {
  lux: {
    title: 'Luxury Escapes',
    value: 'lux',
    brand: 'luxuryescapes',
  },
  scoopon: {
    title: 'Scoopon',
    value: 'scoopon',
    brand: 'scoopontravel',
  },
  cudo: {
    title: 'Cudo',
    value: 'cudo',
    brand: 'cudotravel',
  },
  deals: {
    title: 'Deals',
    value: 'deals',
    brand: 'dealstravel',
  },
  treatme: {
    title: 'Treat Me',
    value: 'treatme',
    brand: 'treatmetravel',
  },
  lebusinesstraveller: {
    title: 'LE Business Traveller',
    value: 'lebusinesstraveller',
    brand: 'lebusinesstraveller',
  },
  leagenthub: {
    title: 'LE Agent Hub',
    value: 'leagenthub',
    brand: 'leagenthub',
  },
  leagenthub_cvfr: {
    title: 'CVFR Holidays',
    value: 'leagenthub_cvfr',
    brand: 'leagenthub_cvfr',
  },
};

/** Header (and tenant pills) use the same brand colours. */
export const TENANT_COLOURS: Record<App.Tenant['value'], { fg: string; bg: string }> = {
  lux: { fg: '#ffffff', bg: '#222' },
  scoopon: { fg: '#eee', bg: '#eb2f3a' },
  cudo: {
    fg: '#fff',
    bg: 'linear-gradient(90deg, rgb(0, 173, 179), rgb(20, 127, 196))',
  },
  deals: {
    fg: '#fff',
    bg: 'linear-gradient(90deg, rgb(20, 127, 211), rgb(0, 170, 245))',
  },
  treatme: {
    fg: '#fff',
    bg: 'linear-gradient(90deg, rgb(255, 111, 0), rgb(255, 65, 0))',
  },
  kogantravel: { fg: '#fff', bg: '#222' },
  lebusinesstraveller: { fg: '#fff', bg: '#009688' },
  zoomzoom: { fg: '#ddd', bg: '#222' },
  leagenthub: { fg: '#eee', bg: '#3f51b5' },
  leagenthub_cvfr: { fg: '#eee', bg: '#2c387e' },
};

export const TENANT_CHIP_LABELS: Record<string, string> = {
  lux: 'LUX',
  scoopon: 'SCOOP',
  lebusinesstraveller: 'LEBT',
};

/** Not every App.Brands value has a tenant here, hence `| undefined`. */
export const tenantByBrand: Record<string, App.Tenant | undefined> = Object.fromEntries(
  Object.values(tenants).map((tenant) => [tenant.brand, tenant]),
);

export const allTenantBrands = Object.values(tenants).map((tenant) => tenant.brand);

/**
 * Admin dropdown values that share the Luxury Escapes auth tenant, matching
 * `validUserTenantForSiteTenant` (svc-auth): Cudo, Deals, and Treat Me.
 * LE Business Traveller is now a separate auth tenant.
 * Agent Hub / CVFR stay separate.
 */
export const LUXURY_ESCAPES_AUTH_TENANT_VALUES: ReadonlyArray<App.Tenant['value']> = [
  'lux',
  'cudo',
  'deals',
  'treatme',
];

export function getAuthTenantValue(adminTenantValue: string): string {
  if ((LUXURY_ESCAPES_AUTH_TENANT_VALUES as ReadonlyArray<string>).includes(adminTenantValue)) {
    return 'lux';
  }
  return adminTenantValue;
}

export function isSameAuthTenant(userTenant: string | undefined, adminTenantValue: string): boolean {
  return Boolean(userTenant) && getAuthTenantValue(userTenant) === getAuthTenantValue(adminTenantValue);
}

export function orderUsersCurrentAuthTenantFirst<T extends { tenant?: string }>(
  users: Array<T>,
  adminTenantValue: string,
): Array<T> {
  const current: Array<T> = [];
  const other: Array<T> = [];

  users.forEach((user) => {
    if (isSameAuthTenant(user.tenant, adminTenantValue)) {
      current.push(user);
    } else {
      other.push(user);
    }
  });

  return current.concat(other);
}

export default tenants;
